<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import VipModernEyebrow from "./vip-modern-eyebrow.svelte";
const icon1Src = cfgToThemeCdnPath("/about-vip/modern/cashback-icon-1.png");
const icon2Src = cfgToThemeCdnPath("/about-vip/modern/cashback-icon-2.png");
const icon3Src = cfgToThemeCdnPath("/about-vip/modern/cashback-icon-3.png");
const icon4Src = cfgToThemeCdnPath("/about-vip/modern/cashback-icon-4.png");
const cards = [
	{
		badgeLetter: "D",
		badgeColor: "var(--color-accent-100)",
		label: Verbiage.vip_modern_daily_cashback_2,
		formula: Verbiage.vip_modern_cashback_daily_formula,
		icon: icon1Src
	},
	{
		badgeLetter: "W",
		badgeColor: "var(--color-primary-500)",
		label: Verbiage.vip_modern_weekly_cashback_050,
		formula: Verbiage.vip_modern_cashback_weekly_formula,
		icon: icon2Src
	},
	{
		badgeLetter: "M",
		badgeColor: "var(--color-warning-300)",
		label: Verbiage.vip_modern_monthly_cashback_010,
		formula: Verbiage.vip_modern_cashback_monthly_formula,
		icon: icon3Src
	},
	{
		badgeLetter: "T",
		badgeColor: "var(--color-highlight-3)",
		label: Verbiage.vip_modern_total_cashback,
		formula: Verbiage.vip_modern_cashback_total_formula,
		icon: icon4Src
	}
];
const splitFormula = (formula) => {
	const idx = formula.lastIndexOf("=");
	if (idx === -1) return {
		left: formula,
		right: ""
	};
	return {
		left: formula.slice(0, idx + 1),
		right: formula.slice(idx + 1).trim()
	};
};
</script>

<section class="vip-cashback">
	<VipModernEyebrow text={$t(Verbiage.cashback)} />

	<div class="vip-cashback-title">
		<Text
			type="title"
			titleSize="h4"
			titleWeight="bold"
			textColor="white"
			className="vip-cashback-title-text"
		>
			{$t(Verbiage.vip_modern_cashback_title_line1)}
		</Text>
		<Text
			type="title"
			titleSize="h4"
			titleWeight="bold"
			textColor="white"
			className="vip-cashback-title-text"
		>
			{$t(Verbiage.vip_modern_cashback_title_line2)}
		</Text>
	</div>

	<div class="vip-cashback-copy">
		<Text type="body" bodySize="large" textColor="gray">
			{$t(Verbiage.vip_modern_cashback_body1)}
		</Text>
		<Text type="body" bodySize="large" textColor="gray">
			{$t(Verbiage.vip_modern_cashback_body2)}
		</Text>
		<Text type="body" bodySize="large" bodyWeight="semibold" textColor="gray">
			{$t(Verbiage.vip_modern_cashback_body3)}
		</Text>
	</div>

	<div class="vip-cashback-grid">
		{#each cards as card (card.formula)}
			{@const formula = splitFormula($t(card.formula))}
			<InfoCard
				modernStyle
				modernGlowPosition="left"
				noPadding
				borderRadius="16px"
				customClass="vip-cashback-card"
			>
				<div class="vip-cashback-card-inner">
					<div class="vip-cashback-card-header">
						<span class="vip-cashback-badge" style="background: {card.badgeColor};">
							{card.badgeLetter}
						</span>
						<Text type="body" bodySize="small" textColor="white">
							{$t(card.label)}
						</Text>
					</div>

					<div class="vip-cashback-icon-wrap">
						<img
							class="vip-cashback-icon"
							src={card.icon}
							alt={$t(Verbiage.illustration_alt, 'alts')}
						/>
					</div>

					<Text type="body" bodySize="medium" textColor="white" className="vip-cashback-formula">
						{formula.left}
						<span class="vip-cashback-formula-highlight">{formula.right}</span>
					</Text>
				</div>
			</InfoCard>
		{/each}
	</div>
</section>

<style>
	.vip-cashback {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 2rem
}

	.vip-cashback :global(.vip-modern-eyebrow) {
		align-self: flex-start
}

	.vip-cashback-title {
		display: flex;
		flex-direction: column
}

	:global(.vip-cashback-title-text) {
		font-size: 32px !important
}

	.vip-cashback-copy {
		display: flex;
		flex-direction: column;
		gap: 0.75rem
}

	@media (min-width: 1024px) {
		.vip-cashback-copy {
				max-width: 50%
		}

		:global(.vip-cashback-title-text) {
				font-size: 37px !important
		}
	}

	.vip-cashback-grid {
		margin-top: 1.5rem;
		display: grid;
		grid-template-columns: repeat(1, minmax(0, 1fr));
		gap: 1rem
}

	@media (min-width: 640px) {

		.vip-cashback-grid {
				grid-template-columns: repeat(2, minmax(0, 1fr))
		}
}

	@media (min-width: 1024px) {

		.vip-cashback-grid {
				grid-template-columns: repeat(4, minmax(0, 1fr))
		}
}

	:global(.vip-cashback-card) {
		width: 100%
}

	.vip-cashback-card-inner {
		display: grid;
		grid-template-columns: 1fr auto;
		align-items: center;
		-moz-column-gap: 1rem;
		     column-gap: 1rem;
		row-gap: 0.5rem;
		padding: 1rem;
		grid-template-areas: 'header icon' 'formula icon'
}

	.vip-cashback-card-header {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		grid-area: header
}

	.vip-cashback-badge {
		display: flex;
		height: 1.5rem;
		width: 1.5rem;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		font-size: 11px;
		font-weight: 700;
		--tw-text-opacity: 1 !important;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}

	.vip-cashback-icon-wrap {
		position: relative;
		display: flex;
		height: 4rem;
		width: 4rem;
		align-items: center;
		justify-content: center;
		border-radius: 9999px;
		grid-area: icon
}

	.vip-cashback-icon {
		height: 100%;
		width: 100%;
		-o-object-fit: contain;
		   object-fit: contain
}

	:global(.vip-cashback-formula) {
		font-weight: 700 !important;
		grid-area: formula
}

	.vip-cashback-formula-highlight {
		font-weight: 600;
		color: var(--color-highlight-3)
}

	@media (min-width: 1024px) {
		.vip-cashback-card-inner {
				display: flex;
				min-height: 220px;
				flex-direction: column;
				align-items: flex-start;
				gap: 1.5rem;
			grid-template-columns: unset;
			grid-template-areas: none
		}

		.vip-cashback-icon-wrap {
				margin-left: auto;
				margin-right: auto;
				height: 97px;
				width: 97px
		}

		:global(.vip-cashback-formula) {
				margin-top: auto;
				font-weight: 400 !important
		}
	}
</style>
